import { Reducer } from 'redux'
import { BlockchainAddress } from '~/store/blockchainAddresses/types'
import { BankAccount } from '~/types'
import {
  ACCEPTED_CURRENCY,
  ActionTypes,
  BANK_TRANSFER_NETWORK,
  Blockchain,
  LANDING_PAGE_ACTIONS,
  STRAITSX_LANDING_PAGE_ACTIONS,
  TRANSFER_METHOD,
} from './types'
import { StablecoinFee } from '~/types/withdraw'

export type StateFlippers = {
  isArbitrumUIEnabled: boolean
  isAvalancheUIEnabled: boolean
  isBnbsmartUIEnabled: boolean
  isEthereumUIEnabled: boolean
  isUSDTBEP20UIEnabled: boolean
  isCkaEnabled: boolean
  isDashboardBannerManagementEnabled: boolean
  isDashboardBannerManagementInitiated: boolean
  isDptApplied: boolean
  isDptRiskModalEnabled: boolean
  isFazzVaForDashboardEnabled: boolean
  isFazzVaForDirectMintEnabled: boolean
  isHederaUIEnabled: boolean
  isHtsWithdrawalFeeCharging: boolean
  isPolygonUIEnabled: boolean
  isRippleUIEnabled: boolean
  isSsoTwoFaAuthenticatorEnabled: boolean
  isTravelRuleAddrWhitelistingEnabled: boolean
  isTransactionDeclarationModalV2Enabled: boolean | undefined
  isTravelRuleDepositDeclarationEnabled: boolean
  isTronUIEnabled: boolean
  isUsdcMaticDepositEnabled: boolean
  isUsdcMaticWithdrawalEnabled: boolean
  isUsdtTrc20DepositEnabled: boolean
  isUsdtTrc20WithdrawalEnabled: boolean
  isXsgdArbDepositEnabled: boolean
  isXsgdArbMintEnabled: boolean
  isXsgdArbWithdrawalEnabled: boolean
  isXsgdAvaxDepositEnabled: boolean
  isXsgdAvaxMintEnabled: boolean
  isXsgdAvaxWithdrawalEnabled: boolean
  isXsgdBep20MintEnabled: boolean
  isXsgdErc20DepositEnabled: boolean
  isXsgdErc20MintEnabled: boolean
  isXsgdErc20WithdrawalEnabled: boolean
  isXsgdHtsDepositEnabled: boolean
  isXsgdHtsMintEnabled: boolean
  isXsgdHtsWithdrawalEnabled: boolean
  isXsgdMaticDepositEnabled: boolean
  isXsgdMaticMintEnabled: boolean
  isXsgdMaticWithdrawalEnabled: boolean
  isXsgdXrpDepositEnabled: boolean
  isXsgdXrpMintEnabled: boolean
  isXsgdXrpWithdrawalEnabled: boolean
  isXsgdZrc2DepositEnabled: boolean
  isXsgdZrc2MintEnabled: boolean
  isXsgdZrc2WithdrawalEnabled: boolean
  isXsgdSplDepositEnabled: boolean
  isXsgdSplMintEnabled: boolean
  isXsgdSplWithdrawalEnabled: boolean
  isXusdSplDepositEnabled: boolean
  isXusdSplMintEnabled: boolean
  isXusdSplWithdrawalEnabled: boolean
  isXusdBep20DepositEnabled: boolean
  isXusdBep20MintEnabled: boolean
  isXusdBep20WithdrawalEnabled: boolean
  isXusdErc20MintEnabled: boolean
  isUsdtBep20DepositEnabled: boolean
  isUsdtBep20WithdrawalEnabled: boolean
  isZilliqaUIEnabled: boolean
  isSolanaUIEnabled: boolean
  isBaseUIEnabled: boolean
  isXsgdBaseDepositEnabled: boolean
  isXsgdBaseMintEnabled: boolean
  isXsgdBaseWithdrawalEnabled: boolean
  isXsgdSplUIEnabled: boolean
  isXusdSplUIEnabled: boolean
  isDashboardApprovalFlowUIEnabled: boolean
}

export type State = StateFlippers & {
  transferMethod: TRANSFER_METHOD | null
  bankTransferNetwork: BANK_TRANSFER_NETWORK | null
  isConfirmOpen: boolean
  selectedBankAccount: BankAccount | null
  selectedCurrency: ACCEPTED_CURRENCY | null
  selectedBlockchain: Blockchain | null
  selectedBlockchainAddress: BlockchainAddress | null
  isCkaEnabled: boolean
  stablecoinFee: StablecoinFee
}

// TODO(benedictkhoo): set type after domain stores are merged into common stores
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const initialState: any = {}

export const landingPage: Reducer<State, ActionTypes> = (state = initialState, action) => {
  switch (action.type) {
    case LANDING_PAGE_ACTIONS.SET_FLIPPERS:
    case STRAITSX_LANDING_PAGE_ACTIONS.SET_FLIPPERS: {
      const flippers: Partial<StateFlippers> = {}

      if (state && action.flippers.size > 0) {
        action.flippers.forEach((value, key) => {
          flippers[key] = value
        })
      }

      return {
        ...state,
        ...flippers,
      }
    }
    default:
      return state
  }
}
